__turbopack_context__.v({
  "clearBtn": "PracticeNameInput-module__35H68a__clearBtn",
  "container": "PracticeNameInput-module__35H68a__container",
  "dropdown": "PracticeNameInput-module__35H68a__dropdown",
  "inputSelected": "PracticeNameInput-module__35H68a__inputSelected",
  "inputWrapper": "PracticeNameInput-module__35H68a__inputWrapper",
  "item": "PracticeNameInput-module__35H68a__item",
  "itemMeta": "PracticeNameInput-module__35H68a__itemMeta",
  "itemName": "PracticeNameInput-module__35H68a__itemName",
  "selectedHint": "PracticeNameInput-module__35H68a__selectedHint",
});
